import { get, compact } from 'lodash-es';
import { TRANSACTION_TYPES_MAP } from 'site-modules/shared/constants/incentives';

export function getIncentiveTitle({ subtype, name, transactionTypes, termMonths }) {
  const term = get(transactionTypes, 'length') === 1 && transactionTypes[0] === 'LEASE' && termMonths;
  const suffix = term ? ` - ${term}mo term` : '';

  const title = subtype && subtype !== 'UNKNOWN' ? subtype : name;

  return `${title}${suffix}`;
}

export function getTransactionTypes({ transactionTypes = [] }) {
  return compact(transactionTypes.map(type => TRANSACTION_TYPES_MAP[type]).sort()).join(', ');
}

export function getFormattedIncentives(incentives = []) {
  return incentives.sort((a, b) => new Date(a.endDate) - new Date(b.endDate));
}
